<template>
    <div class="flex items-center">
        <div class="flex-1 rounded | transition duration-300 | focus-within:shadow-lg">
            <nio-input
                class="flex-1"
                class-name="rounded-b-none"
                mask="phone"
                :value="numberWithoutCountryCode"
                @input="updateNumber"
            />

            <div class="flex-1 flex justify-between items-center p-2 border-l border-r border-b border-gray-200 rounded-b">
                <div class="flex items-center">
                    <nio-icon
                        class="mr-2"
                        :class="statusIconColor"
                        :name="statusIcon"
                    />

                    <span v-tooltip="validationText">
                        {{ $t('contacts.contactModal.validate') }}
                    </span>
                </div>

                <nio-button
                    color="blue"
                    :loading="validating"
                    @click="validateNumber"
                    v-if="validateEnabled"
                >
                    {{ $t('contacts.contactModal.validate') }}
                </nio-button>
            </div>
        </div>

        <button
            class="flex justify-center items-center p-4 -mr-4 text-lg | transition duration-300 hover:text-red-500"
            :disabled="!showDelete"
            @click="deletePhone"
        >
            <nio-icon name="regular/bin-2-alternate" />
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            phone: {
                type: Object,
                required: true,
            },
            number: {
                type: String,
                required: true,
            },
            showDelete: {
                type: Boolean,
                default: false,
            },
            updating: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                validating: false,
            };
        },

        computed: {
            numberWithoutCountryCode() {
                return this.number.substring(0, 2) === '+1'
                    ? this.number.substring(2)
                    : this.number;
            },

            status() {
                if (this.phone.valid && this.phone.type == 'mobile') {
                    return 'valid';
                }

                if (!this.phone.validated) {
                    return 'unknown';
                }

                return 'invalid';
            },

            statusIcon() {
                if (this.status == 'valid') {
                    return 'bold/check-circle-1';
                }

                if (this.status == 'invalid') {
                    return 'bold/remove-cricle';
                }

                return 'bold/alert-triangle';
            },

            statusIconColor() {
                if (this.status == 'valid') {
                    return 'text-green-500';
                }

                if (this.status == 'invalid') {
                    return 'text-red-500';
                }

                return 'text-yellow-500';
            },

            statusText() {
                if (this.status == 'valid') {
                    return this.$t('global.phoneStatus.valid');
                }

                if (this.status == 'invalid') {
                    return this.$t('global.phoneStatus.invalid');
                }

                return this.$t('global.phoneStatus.notValidated');
            },

            validateEnabled() {
                return this.updating &&
                    this.phone.id &&
                    this.number &&
                    !this.phone.validated;
            },

            validationText() {
                if (!this.phone.id) {
                    return this.$t('contacts.contactModal.validationTooltip.userMustBeSaved');
                }

                if (this.phone.validated) {
                    return this.$t('contacts.contactModal.validationTooltip.alreadyValidated');
                }

                return '';
            },
        },

        methods: {
            async validateNumber() {
                this.validating = true;

                try {
                    const response = await this.$axios.get(`contact-phones/${this.phone.id}/validate`);

                    this.$emit('update-phone', response.data.data);

                    this.validating = false;
                } catch (error) {
                    this.validating = false;

                    this.$notify.show({
                        type: 'error',
                        message: this.$t('global.errors.unknown'),
                    });

                    throw error;
                }
            },

            updateNumber(number) {
                this.$emit('update:number', `+1${number}`);
            },

            deletePhone() {
                this.$emit('delete-phone', this.phone);
            },
        },
    };
</script>
